import axios from 'axios'

const url = process.env.VUE_APP_RECON_URL
const ipniUrl = process.env.VUE_APP_IPNI_RECON_URL

const api = axios.create({
  baseURL: url
})

const ipniApi = axios.create({
  baseURL: ipniUrl
})

const match = function(data, useIpni) {
  if(useIpni){
    return ipniApi.post("/match",  data)
  }else{
    return api.post("/match",  data)
  }
}

const matchCsv = function(data, column, hasHeaders, allColumns, currentChunk, useIpni) {
  if(useIpni){
  return ipniApi.post("/csv",  { data: data, column: column, headers: hasHeaders, outputAllColumns : allColumns, currentChunk: currentChunk})
}else{
  return api.post("/csv",  { data: data, column: column, headers: hasHeaders, outputAllColumns : allColumns, currentChunk: currentChunk})
}
}

const download = function(data, fileName) {
    let blob = new Blob([data], { type:   'application/csv' } )
    let link = document.createElement('a')
    link.style = "display: none";
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName.substr(0, fileName.lastIndexOf('.')) + '_matched_' + Date.now() + ".csv"
    document.body.appendChild(link);
    link.click()
    setTimeout(function(){
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1);
}

export default {
  match,
  matchCsv,
  download
}
